export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }